// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"da61e8c7","477":"566c73c8","560":"c27f1a16","654":"32b05f58","994":"c58ef3dc"}[chunkId] + ".chunk.css";
};